module.exports = __webpack_public_path__ + "static/media/winstar.fe30581d.png";